<template>
    <div id="new_year">
        <div class="img-box">
            <div class="top_part">
                <img class="top-back-img" src="@/assets/active/new-year/1.png" alt="">
            </div>
            <div class="middle-part">
                <img src="@/assets/active/new-year/2.png" alt="">
            </div>
            <div class="third-part">
                <img src="@/assets/active/new-year/3.png" alt="">
            </div>
            <!-- <div class="third-part-1">
                <img src="@/assets/active/new-year/4.png" alt="">
            </div> -->
            <div class="four-part">
                <img src="@/assets/active/new-year/4.png" alt="">
                <!-- <div class="phone-box">
                    <div>QQ群号</div>
                    <span class="tme">666376678</span>
                    <span class="copy my_code" @click="copy('666376678')">
                        <img src="@/assets/active/new-year/white_copy.png">
                    </span>
                </div> -->
                <div class="tme-box">
                    <!-- <div>使用梯子后，打开浏览器扫码进入电报群，或使用链接进群</div> -->
                    <span class="tme">https://t.me/jinguozi001</span>
                    <span class="copy my_code" @click="copy('https://t.me/jinguozi001')">
                        <img src="@/assets/active/new-year/white_copy.png">
                    </span>
                </div>
            </div>
            
            <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
                <span class="mask-tip">请在浏览器中打开</span>
                <img src="@/assets/down/tip_arrow.png"/>
            </div>
        </div>
        <div class="button_box">
            <button @click="down">点击注册下载APP</button>
        </div>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
    name: 'ProDownload01',
    data() {
        return {
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',
            alertShow: false,
            message: ''
        }
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        down() {
            const host = window.location.host
            // const host = 'https://misc.jgzpro.com'
            window.open(window.location.protocol + "//" + window.location.host + '/sign-in/?language=CHINESE&inviteCode=VTCKAL')
        },
        openTg() {
            window.open('https://t.me/jinguozi001')
        },
        copy(str) {
            // let str = 'https://t.me/jinguozi001'
            let clipboard = new Clipboard('.my_code', {
                text: function () {
                    return str
                }
            })
            console.log(clipboard)
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
    }
}
</script>

<style lang='less'>
#new_year {
	height: 100vh;
	width: 100vw;
	background: #111125;;
    position: relative;
    padding-bottom: 120px;
    img {
        pointer-events: none;
    }
    button {
        width: 640px;
        height: 88px;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 2px;
        background: linear-gradient(98deg,#fa9a0a 62%, #fa600a 100%); 
        box-shadow: -5px 0px 0px 0px rgba(255,207,152,0.81);
        position: absolute;
        color: #ffffff;
        font-size: 32px;
        font-weight: bold;
        left: 55px;
    }
    .img-box {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    .button_box {
        width: 100vw;
        position: absolute;
        height: 208px;
        bottom: 0;
        left: 0;
        line-height: 200px;
        background: #131729;
        button {
            top: 60px;
        }
        p {
            position: absolute;
            top: 120px;
            color: #191929;
            font-size: 24px;
            padding: 0 80px;
            line-height: 30px;
            width: 100vw;
            text-align: center;
        }
    }
    .top_part {
        width: 100vw;
        height: 726px;
        position: relative;
        .top-back-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
        }
    }
    .middle-part {
        position: relative;
        img {
            width: 100vw;
        }
        .button_box {
            width: 60vw;
            position: absolute;
            top: 265px;
            right: 40px;
            height: 90px;
            opacity: 0;
        }
        button {
            left: 0;
        }
    }
    .third-part {
        img {
            width: 100vw;
        }
    }
    .third-part-1 {
        img {
            width: 100vw;
        }
    }
    .four-part {
        position: relative;
        img {
            width: 100vw;
        }
        .phone-box {
            position: absolute;
            width: 326px;
            right: 34px;
            top: 384px;
            font-size: 24px;
            color: #ffffff;
            line-height: 30px;
            // padding-left: 20px;
            span {
                vertical-align: middle;
                margin-right: 20px;
            }
            img {
                vertical-align: middle;
                width: 50px;
                height: 50px;
            }
            .tme {
                padding-left: 60px;
            }
        }
        .tme-box {
            position: absolute;
            width: 326px;
            left: 320px;
            top: 224px;
            font-size: 24px;
            color: #ffffff;
            line-height: 30px;
            span {
                vertical-align: middle;
                margin-right: 20px;
            }
            img {
                vertical-align: middle;
                width: 40px;
                height: 40px;
            }
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>
